import * as THREE from "three/webgpu";
import Experience from "../Experience.js";
import {CameraHelper} from "three";

export default class Environment {
    constructor() {
        this.experience = new Experience();
        this.scene = this.experience.scene;
        this.resources = this.experience.resources;
        this.debug = this.experience.debug;
        
        if (this.debug.active)
        {
            this.debugFolder = this.debug.ui.addFolder('Environment').open();            
        }
        
        this.sunLightParameters = {
            position: new THREE.Vector3(12.5, 15, 9.5),
            target: new THREE.Vector3(0, 0, 0),
            intensity: 1,
            castShadow: true,
            shadow: {
                camera: {
                    top: 10,
                    bottom: -10,
                    left: -10,
                    right: 10,
                    near: 1,
                    far: 50
                }
            }
        };
        
        this.setSunLight();
        //this.setAmbientLight();
        //this.setEnvironmentMap();
        this.setDebug();
    }

    setSunLight() {
        // Lights
        this.sunLight = new THREE.DirectionalLight(0xffffff, this.sunLightParameters.intensity);
        this.sunLight.position.copy(this.sunLightParameters.position);
        this.sunLight.target.position.copy(this.sunLightParameters.target);
        this.sunLight.castShadow = this.sunLightParameters.castShadow;
        this.sunLight.shadow.camera.top = this.sunLightParameters.shadow.camera.top;
        this.sunLight.shadow.camera.bottom = this.sunLightParameters.shadow.camera.bottom;
        this.sunLight.shadow.camera.left = this.sunLightParameters.shadow.camera.left;
        this.sunLight.shadow.camera.right = this.sunLightParameters.shadow.camera.right;
        this.sunLight.shadow.camera.near = this.sunLightParameters.shadow.camera.near;
        this.sunLight.shadow.camera.far = this.sunLightParameters.shadow.camera.far;
        
        this.sunLightHelper = new CameraHelper(this.sunLight.shadow.camera);
        this.sunLightHelper.visible = false;
        this.scene.add(this.sunLightHelper);
        
        this.scene.add(this.sunLight);
        this.scene.add(this.sunLight.target);       
    }
    
    setAmbientLight()
    {
        this.ambientLight = new THREE.AmbientLight(0xffffff, 0.1);
        this.scene.add(this.ambientLight);
    }

    setEnvironmentMap() {
        this.environmentMap = {};
        this.environmentMap.intensity = 1.4;
        this.environmentMap.texture = this.resources.items.environmentMapTexture;
        this.environmentMap.colorSpace = THREE.SRGBColorSpace;
        
        this.scene.environment = this.environmentMap.texture;
        this.scene.background = new THREE.Color(0, 0,0);
        
        this.environmentMap.updateMaterials = () => {
            this.scene.traverse((child) => {
               if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial) {
                   child.material.envMap = this.environmentMap.texture;
                   child.material.envMapIntensity = this.environmentMap.intensity;
                   child.material.needsUpdate = true;
                }
            });
        }
        
        this.environmentMap.updateMaterials();
    }
    
    setDebug() {
        if (!this.debug.active) {
            return;
        }

        const sunLightFolder = this.debugFolder.addFolder('sunLight').open();

        sunLightFolder.add(this.sunLight, 'intensity').name('intensity').min(0).max(10).step(0.01);

        sunLightFolder.add(this.sunLight.position, 'x').name('posX').min(-50).max(50).step(0.1);
        sunLightFolder.add(this.sunLight.position, 'y').name('posY').min(-50).max(50).step(0.1);
        sunLightFolder.add(this.sunLight.position, 'z').name('posZ').min(-50).max(50).step(0.1);

        sunLightFolder.add(this.sunLight.target.position, 'x').name('targetX').min(-50).max(50).step(0.1);
        sunLightFolder.add(this.sunLight.target.position, 'y').name('targetY').min(-50).max(50).step(0.1);
        sunLightFolder.add(this.sunLight.target.position, 'z').name('targetZ').min(-50).max(50).step(0.1);

        const shadowFolder = sunLightFolder.addFolder('shadow').close();

        shadowFolder.add(this.sunLight.shadow.camera, 'top').name('top').min(-50).max(50).step(0.1).onChange(() => this.sunLight.shadow.camera.updateProjectionMatrix());
        shadowFolder.add(this.sunLight.shadow.camera, 'bottom').name('bottom').min(-50).max(50).step(0.1).onChange(() => this.sunLight.shadow.camera.updateProjectionMatrix());
        shadowFolder.add(this.sunLight.shadow.camera, 'left').name('left').min(-50).max(50).step(0.1).onChange(() => this.sunLight.shadow.camera.updateProjectionMatrix());
        shadowFolder.add(this.sunLight.shadow.camera, 'right').name('right').min(-50).max(50).step(0.1).onChange(() => this.sunLight.shadow.camera.updateProjectionMatrix());
        shadowFolder.add(this.sunLight.shadow.camera, 'near').name('near').min(-50).max(50).step(0.1).onChange(() => this.sunLight.shadow.camera.updateProjectionMatrix());
        shadowFolder.add(this.sunLight.shadow.camera, 'far').name('far').min(-50).max(100).step(0.1).onChange(() => this.sunLight.shadow.camera.updateProjectionMatrix());
        shadowFolder.add(this.sunLightHelper, 'visible').name('helperVisible');
    }
}